import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { loggedUser } from 'app/store/login/logged-user/logged-user.selectors';
import { selectFirst } from 'core/utils/rx-common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NoAuthGuard {
  constructor(private router: Router, private store$: Store) {}

  canActivate(): Observable<boolean> {
    return this.store$.pipe(
      selectFirst(loggedUser),
      map((user) => {
        if (user !== null) {
          this.router.navigate(['project']);
          return false;
        }

        return true;
      }),
    );
  }

  canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }
}
